module.exports = __webpack_public_path__ + "media/djembe-pou.69d79f72.wav";